import React, { FC } from "react";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { usePatchObservationForm } from "../../hooks";

interface Props {
	questionsLength: number;
	isDisabled?: boolean;
}

const ObservationPassRate: FC<Props> = ({ questionsLength, isDisabled }) => {
	const { control, trigger, setValue } = useFormContext<AdminObservationForm>();

	const { observationFormId } = useWatch({
		control
	});

	const { mutate: submitScoreThreshold, isLoading: isUpdatingScoreThreshold } =
		usePatchObservationForm();

	const { field } = useController({
		control,
		name: "observationScoreThreshold",
		rules: { required: true }
	});

	const handleSubmitScoreThreshold = async () => {
		if (!observationFormId) return;

		const { value: scoreThreshold } = field;

		let computedScoreThreshold = scoreThreshold;

		if (scoreThreshold && scoreThreshold > questionsLength) {
			computedScoreThreshold = questionsLength;
		}

		if (scoreThreshold && scoreThreshold < 1) {
			computedScoreThreshold = 1;
		}

		submitScoreThreshold({
			id: observationFormId,
			score_threshold: computedScoreThreshold
		});
	};

	const handleFocus = () => {
		trigger();
		setValue("selectedQuestionIndex", null);
	};

	const isSingleQuestion = questionsLength === 1;

	return (
		<>
			<div
				className={`border border-border bg-accent rounded-lg ${isDisabled ? "opacity-60 pointer-events-none" : ""}`}
			>
				<div className="flex px-4 py-5 justify-between items-center">
					<div>
						<label className="block font-bold">Observation pass rate</label>
						<label className="block mb-0">
							This form will be scored out of {questionsLength}{" "}
							{isSingleQuestion ? "point" : "points"}, what would you like to
							set the pass rate at?
						</label>
					</div>

					<div className="flex items-center gap-2">
						<input
							type="number"
							min={1}
							max={questionsLength}
							className="bg-white border-0 w-fit max-w-[55px] font-bold p-0 text-center text-lg focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50"
							{...field}
							value={field.value ?? ""}
							disabled={isUpdatingScoreThreshold || isDisabled}
							onBlur={handleSubmitScoreThreshold}
							onFocus={handleFocus}
							aria-label="score-threshold-input"
						/>

						<span className="font-bold text-lg opacity-[inherit]">
							/ {questionsLength}
						</span>
					</div>
				</div>
			</div>
		</>
	);
};

export default ObservationPassRate;
